import useToggle from '../../hook/useToggle';

type AccordionContainerProps = {
  title: string;
  children: any;
  className?: string;
  titleClass?: string;
}

const AccordionContainer = (props: AccordionContainerProps) => {
  const { title, children, className, titleClass } = props;

  const { isOpen, toggle } = useToggle(true);

  return (
    <div className={className}>
      <div className="accordion" id="accordion_container">
        <div className="accordion-item">
          <h2 className="accordion-header">
            <button
              className={`accordion-button ${!isOpen ? 'collapsed' : ''} ${titleClass}`}
              type="button"
              onClick={toggle}
              aria-expanded={isOpen}
              aria-controls="collapseOne"
            >
              {title}
            </button>
          </h2>
          <div
            id="collapseOne"
            className={`accordion-collapse collapse ${isOpen ? 'show' : ''}`}            
            data-bs-parent="#accordion_container"
          >
            <div className="accordion-body">
              {children}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AccordionContainer;
